<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <h2>{{ message }}</h2>
                    </v-card-text>
                    <v-card-actions>
                        <v-progress-linear indeterminate color="primary" v-if="!failed"/>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: "Plugin",
    data: () => ({
        timeout: null,
        failed: false,
        homePage: null,
        tries: 0,
        maxTries: 5
    }),
    created() {
        this.initialize();
    },
    computed: {
        message() {
            return this.failed ? this.$t("system.redirectingFailed") : this.$t("system.redirecting");
        }
    },
    methods: {
        initialize() {
            console.log("Plugin");
            this.redirect();
        },
        redirect() {
            if (this.tries < this.maxTries) {
                this.homePage = sessionStorage.getItem("home");
                if (this.homePage) {
                    clearTimeout(this.timeout);
                    this.$router.push(this.homePage);
                } else {
                    this.timeout = setTimeout(() => {
                        this.redirect();
                        }, 1000);
                    this.tries++;
                }
            } else {
                clearTimeout(this.timeout);
                this.failed = true;
            }
        }
    }
    
}
</script>
<style>
    
</style>